export default __webpack_public_path__ + "static/media/req_hmc_service_icon.5a4b7711.png";